import React from 'react';
import Visionn from './Visionn';

const Aboutsectionn = () => {
 
  return (
   <>
    <section
        className="page-title"
        style={{ backgroundImage: 'url(/images/background/3.jpg)', backgroundSize: 'cover', backgroundPosition: 'center', padding: '100px 0', color: '#fff', textAlign: 'center' }}
      >
        <div className="auto-container">
          <h1 style={{ fontSize: '36px', fontWeight: 'bold' }}>About Us </h1>
        </div>
      </section>
    <section className="experiance-section">
      <div className="auto-container">
        <div className="row clearfix">
          {/* Content Column */}
          <div className="content-column col-md-6 col-sm-12 col-xs-12">
            <div className="inner-box">
              <h3>
                <a href="/services">About eTravo Cab Services</a>
              </h3>
              <div className="text">
                <p>This company is one of the finest in the field of people mobility in India, with two separate divisions to service clients in the areas of executive and employee car rental, as well as travel agents, tour operators, and event management companies for their ground transportation requirements. We can provide Chauffeur Driven service in a wide range of vehicles including sedans, SUVs, INNOVA CRYSTA, 17STR AC BUS, 26STR AC BUS, 32STR AC BUS, 45STR AC BUS, 49STR AC BUS, and 49STR AC VALVO.

With a professional management team and offices in Pune, eTravo is one of India's largest B2B passenger transportation companies. As a result of our partnership with eTravo, we are able to offer our clients access to top quality cars. In addition, we offer service coverage across all major cities and towns across India, ensuring nationwide reach for your transportation needs.

eTravo has always been a leader in the technology space, driving every aspect of the business with innovative technology with the goal of providing seamless customer service. Our brand has been built on operational excellence and repeat customers over the years. This is thanks to all our loyal clients and team members who have stood by us throughout our journey.</p>
                <p>We started out as a company that provided car rental services in 2011 before we moved on to become a company that provided tour and travel services in 2011. As the goal was to offer domestic and international tours, our team had to be disciplined and experienced. We are a member of the Travel Agent Federation of India. With our commitment to providing travel and exploring facilities to our clients, we have been able to carve out a prestigious position in the industry. A variety of known as well as unknown wonders are waiting to be experienced and we are here to help make your journey a more enjoyable one. It is our goal to provide you with a customized package for your holidays that you can never forget by leveraging our expertise.</p>
              </div>
              {/* <a href="/services" className="read-more">READ MORE</a> */}
            </div>
          </div>

          {/* Form Column */}
          <div className="form-column col-md-6 col-sm-12 col-xs-12">
            <div className="inner-box">
              <div className="default-form">
               <img src='/images/ABOUT_US.jpg' alt='about-img'/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Visionn/>
   </>
  );
};

export default Aboutsectionn;
